export default __webpack_public_path__ + "static/media/javascript.04ae7867.png";